export enum jobStatusTypes {
  // *exists*
  pending = "pending",
  // has an order
  confirmed = "confirmed",
}
